import { Injectable, ElementRef} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { XmlparseService } from '../xml/xmlparse.service';

import { AlertService } from "../../services/alert/alert.service";
import { LoginService } from '../../login/login.service';

declare var require: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleService extends XmlparseService  {

  // Data members
  recaptchaToken: string = "";

  constructor(private http: HttpClient, private alertSvc: AlertService, private loginSvc: LoginService) {
    super(alertSvc, loginSvc);
  }

  initializeRecaptchaScript(recaptchaElement: ElementRef) {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha(recaptchaElement);
    }

    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptcha(recaptchaElement); return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }

  private renderReCaptcha(recaptchaElement: ElementRef) {
    window['grecaptcha'].render(recaptchaElement.nativeElement, {
      'sitekey': '6LeFTjQUAAAAAMA_mIh5ednUwhzeUo0EqlK2jHmP',
      'callback': (response) => {
        this.recaptchaToken = response;
      }
    });
  }

  public verifyRecaptcha(resToken: string): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Environment config. is not found.";

    let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=verifyrecaptcha&key=" + encodeURIComponent(resToken);
    return this.http.get(url, { responseType: 'text' }).pipe(
      map(
        response => super.geticexdocumentobjects(response, ["MESSAGE"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }
}
